Page['o-lab'] = () => {
	$('.o-lab-v1-nh-slider').slick({
		arrows: true,
		// autoplay: 2000,
		slidesToShow: 6,
		slidesToScroll: 2,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 460,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	})

	$('.o-lab-v1-slider').slick({
		arrows: true,
		autoplay: 2000,
		slidesToShow: 1,
		slidesToScroll: 1,
	})
}
